module.exports = __webpack_public_path__ + "img/corner-left-up.643994b6.svg";